module.exports = __webpack_public_path__ + "img/b.774c029d.jpg";